import { Injectable } from '@angular/core';
import {UrlQueryService} from '../../../../common/url-query/url-query.service';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CredentialsSettingsApiService {

  constructor(private http: HttpClient) {}

  readonly credentialsUrl: string = 'security/credentials';

  public getCredentials(type: string, parameters): Observable<any> {
    return this.http.get(this.generateCredentialsUrl(parameters, type));
  }

  public addNewCredentials(credentials: any): Observable<any> {
    return this.http.post(this.credentialsUrl, credentials);
  }

  public updateCredentials(credentials: any): Observable<any> {
    return this.http.put(`${this.credentialsUrl}/${credentials.id}`, credentials);
  }

  public deleteCredentials(id: number): Observable<any> {
    return this.http.delete(`${this.credentialsUrl}/${id}`);
  }

  private generateCredentialsUrl(params: any = {}, credentialsType): any {
    params.filter = {
      type: {
        operator: '=',
        value: credentialsType
      }
    };

    return UrlQueryService.addQueryParameters(this.credentialsUrl, params);
  }
}
